import { render, staticRenderFns } from "./gallery-video.vue?vue&type=template&id=066d7a65&"
import script from "./gallery-video.vue?vue&type=script&lang=ts&"
export * from "./gallery-video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports